import { Form } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import Categories from "../Categories";
import ExitConfirm from "../ExitConfirm";
import ThankYou from "../ThankYou";
import TownDetails from "../TownDetails";
import TownUpload from "../TownUpload";
import { useForm } from "react-hook-form";
import { KeepAlive } from "react-keep-alive";

const TownFormWrapper = (props) => {
  const { currentStep } = useSelector((state) => state.globalSlice);
  const { control, handleSubmit } = useForm();

  const onSubmit = (data) => {
    console.log("aaa", data);
  };

  const renderStep = () => {
    switch (currentStep) {
      case "upload":
        return (
          <>
            {/* <KeepAlive name="TownUpload">
              <TownUpload />
            </KeepAlive> */}
            <TownUpload />
          </>
        );

      case "detail":
        return <TownDetails />;

      case "thankyou":
        return <ThankYou />;

      case "confirm":
        return <ExitConfirm />;

      default:
        return (
          <>
            {/* <KeepAlive name="Categories">
              <Categories />
            </KeepAlive> */}
            <Categories />
          </>
        );
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="form_upload_wrapper">
      {renderStep()}

      {/* <TownUpload /> */}
    </form>
  );
};

TownFormWrapper.propTypes = {};

export default TownFormWrapper;
